var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmailIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 41,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  y: 0.667,
  fill: "#D1E9FF",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#102A56",
  d: "M26 29.417H14c-2.418 0-3.75-1.333-3.75-3.75v-9c0-2.419 1.332-3.75 3.75-3.75h12c2.418 0 3.75 1.332 3.75 3.75v9c0 2.417-1.332 3.75-3.75 3.75m-12-15c-1.577 0-2.25.672-2.25 2.25v9c0 1.576.673 2.25 2.25 2.25h12c1.577 0 2.25-.674 2.25-2.25v-9c0-1.578-.673-2.25-2.25-2.25zm7.03 7.429 4.91-3.573a.75.75 0 1 0-.882-1.212l-4.912 3.572a.25.25 0 0 1-.293 0l-4.912-3.572a.75.75 0 0 0-.883 1.212l4.912 3.573a1.75 1.75 0 0 0 2.06 0"
})));
export default SvgEmailIcon;